import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CommunityProviderProgramService } from '../service/community-provider-program.service';

@Injectable({
    providedIn: 'root'
})
export class CommunityProviderProgramValidators
{
    constructor(private communityProviderProgramService: CommunityProviderProgramService) { }

    public validateCommunityServiceCategoryNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.communityProviderProgramService.existsCommunityProviderProgramName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
